module.exports = __webpack_public_path__ + "static/fixture-c84ccf5722bef12c76e96265b5195db4.png";